import { DataTable } from "@/components";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { Plus } from "lucide-react";
import useCurriculumInfo from "./useCurriculumInfo";
import AddEditCurriculum from "./AddEdit/AddEditCurriculum";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { LOGIN_ROLES } from "@/lib/utils";

const CurriculumInfo = () => {
  const {
    columns,
    tableData,
    pageNumber,
    totalPages,
    pageSize,
    totalRecords,
    setPageNumber,
    setPageSize,
    handleAddNew,
    isFormOpen,
    editingCurriculum,
    handleFormClose,
    // Delete functionality
    isDeleteDialogOpen,
    deletingRow,
    handleDeleteConfirm,
    handleDeleteCancel,
    isDeleting,
  } = useCurriculumInfo();

   const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  // 👇 backend sends role as array, e.g. ["CRM_HEAD"]
  const roles = loggedInUserData?.role || [];

  // Helper to check if user has a given role
  const hasRole = (role: string) =>
    Array.isArray(roles) && roles.includes(role);

  const restrictedRoles = [LOGIN_ROLES.SALES_OPS, LOGIN_ROLES.INVENTORY_TEAM, LOGIN_ROLES.LABS_TEAM, LOGIN_ROLES.FINANCE_TEAM];
  const canShowActionButton = !restrictedRoles.some(role => hasRole(role));

  return (
    <div className="bg-white p-5">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-[18px] text-primary ">Curriculum Master</h2>
        <div className="flex items-center space-x-2">
          {canShowActionButton && 
          <Button
            type="button"
            className="bg-primary text-white"
            onClick={handleAddNew}
          >
            <Plus className="w-4 h-4 mr-2" />
            Add New
          </Button>
          }
        </div>
      </div>
      <DataTable
        columns={columns}
        data={tableData}
        serviceSidePagination={true}
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalPages={totalPages}
        totalRecords={totalRecords}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
      />
      <AddEditCurriculum
        onCancel={handleFormClose}
        open={isFormOpen}
        editData={editingCurriculum}
      />

      <Dialog open={isDeleteDialogOpen} onOpenChange={handleDeleteCancel}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Delete Curriculum Class</DialogTitle>
            <DialogDescription>
              Are you sure you want to delete this curriculum class? This action
              cannot be undone.
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-end gap-3 mt-4">
            <Button variant="outline" onClick={handleDeleteCancel}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={() => handleDeleteConfirm("")}
              disabled={isDeleting}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CurriculumInfo;
